import { render } from "./JFrecall.vue?vue&type=template&id=fa0b3aec&scoped=true"
import script from "./JFrecall.vue?vue&type=script&lang=js"
export * from "./JFrecall.vue?vue&type=script&lang=js"

import "./JFrecall.vue?vue&type=style&index=0&id=fa0b3aec&lang=scss&scoped=true"
import "./JFrecall.vue?vue&type=style&index=1&id=fa0b3aec&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa0b3aec"]])

export default __exports__